
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import isPossiblePrototype$1 from './is-possible-prototype.js';

var isPossiblePrototype = isPossiblePrototype$1;

var $String = String;
var $TypeError = TypeError;

var aPossiblePrototype = function (argument) {
  if (isPossiblePrototype(argument)) return argument;
  throw new $TypeError("Can't set " + $String(argument) + ' as a prototype');
};

export { aPossiblePrototype as default };
//# sourceMappingURL=a-possible-prototype.js.map
